export const streamAppNames = ["eh-alerts-input-raw", "eh-alerts-worker"];
export const streamTableNames = ["eh_alerts"];
export const streamNames = ["eh-alerts-stocks", "eh-alerts-crypto"];
